window.copyTranslationKey = (event: Event, key: string) => {
  event.stopPropagation(); // Prevent other click events from firing

  navigator.clipboard.writeText(key).then(() => {
    console.log(`Translation key copied: ${key}`);
    // Optional: Provide visual feedback to the user
    const target = event.currentTarget as HTMLElement;
    if (target) {
      const originalTitle = target.title;
      const originalInnerHTML = target.innerHTML;

      target.title = 'Copied!';
      target.innerHTML = '<i class="ri-check-line"></i>'; // Use a check icon

      setTimeout(() => {
        target.title = originalTitle;
        target.innerHTML = originalInnerHTML;
      }, 1500); // Revert after 1.5 seconds
    }
  }).catch(err => {
    console.error('Failed to copy translation key: ', err);
  });
};